export const colorCode = {
    "data": 
        { "Silver":"#c0c0c0",
          "Black": "#000000", 
          "Multicolor" : "#e5e5e5",
          "White" : "#ffffff",
          "Blue" : "#4146AB",
          "Pink" : "#E896CA",
          "Green" : "#087B3C",
          "Brown" : "#643B37",
          "Tan" : "#d2b48c",
          "Gold" : "#ffd700",
          "Grey" : "#979797",
          "Metallic" : "#B6A489",
          "Neutrals" : "#D6C5B9",
          "Orange" : "#E17C54",
          "Grey" : "#979797",
          "Purple" : "#8718B4",
          "Red" : "#CF1818",
          "Yellow" : "#FFDC4A",

        },
        "hide":['home-gifts','beauty']
      
};
  